const breakpoints = {
	min_xxs: 360,
	max_xxs: 480,
	min_xs: 481,
	max_xs: 575,
	min_s: 576,
	max_s: 767,
	min_m: 768,
	max_m: 991,
	min_l: 992,
	max_l: 1279,
	min_xl: 1280,
	max_xl: 1439,
	min_xxl: 1440,
	max_xxl: 1919,
	min_xxxl: 1920,
	max_xxxl: 2559,
};

export { breakpoints };
